import React from "react";

import NavSearch from "components/NavSearch";
import RecipeResults from "components/RecipeResults";

function SearchResults() {
  return (
    <>
      {/* NavSearch component */}
      <NavSearch />

      {/* RecipeResults component used by both Home and Search Results page */}
      <RecipeResults />
    </>
  );
}

export default SearchResults;